import "./FloatingTextArea.css";
import React from "react";
import { TextField } from "@mui/material";

const FloatingTextArea = ({
  className,
  forLabel,
  id,
  label,
  onBlur,
  onChange,
  onClick,
  // placeholder, // not used — MUI uses label for the floating label
  value,
}) => {
  const isInvalid = className?.includes("invalid");
  const hasValue = !!value;
  const wrapperClass = className?.replace(/\binvalid\b/, "").trim() || "";

  return (
    <div className={` ${wrapperClass}`} onClick={onClick}>
      <TextField
        multiline
        rows={10}
        id={id || forLabel}
        label={label}
        variant="outlined"
        value={value ?? ""}
        onChange={onChange}
        onBlur={onBlur}
        sx={{
          width: "100%",
          "& .MuiFormLabel-root": {
            fontSize: "13px",
            fontFamily: "Graphik Medium",
            color: "#9A9B9B",
          },
          "& .MuiFormLabel-root.Mui-focused": {
            color: "#9A9B9B",
          },
          "& .MuiOutlinedInput-notchedOutline legend": {
            lineHeight: "11px",
            fontSize: "9.75px",
          },
          "& .MuiOutlinedInput-root": {
            fontSize: "14px",
            color: "#000",
            fontFamily: "Graphik Medium",
            borderRadius: "12px",
            backgroundColor: hasValue ? "#ffffff" : "#f7f7f7",
            "& fieldset": {
              borderColor: isInvalid ? "red" : hasValue ? "#11B700" : "rgba(0, 0, 0, 0.23)",
              borderWidth: hasValue ? "2px" : "1px",
              borderRadius: "12px",
            },
            "&:hover": {
              backgroundColor: "#ffffff",
            },
            "&:hover fieldset": {
              borderColor: isInvalid ? "red" : "#11B700",
              borderWidth: "2px",
            },
            "&.Mui-focused": {
              backgroundColor: "#ffffff",
            },
            "&.Mui-focused fieldset": {
              borderColor: isInvalid ? "red" : "#11B700",
              borderWidth: "2px",
            },
          },
        }}
      />
    </div>
  );
};

/* OLD Bootstrap form-floating implementation
const FloatingTextAreaOld = ({
  className,
  forLabel,
  id,
  label,
  onBlur,
  onChange,
  onClick,
  placeholder,
  value,
}) => {
  return (
    <>
      <div className={`CopyItCustomTextArea ${className}`}>
        <div className="form-floating">
          <textarea
            className={`form-control fs15`}
            id={id}
            onBlur={onBlur}
            onChange={onChange}
            placeholder={placeholder}
            rows={10}
            value={value}
          />
          <label htmlFor={forLabel}>{label}</label>
        </div>
      </div>
    </>
  );
};
*/

export default FloatingTextArea;
